import axios from "axios";
import { API_BASEURL, CONTENT_BASE_URL } from "./api";
import type { ContactUsSchema } from "app/schema/contactus.schema";

const sendContactMessageApi = async (payload: ContactUsSchema) => {
  return await axios.post(`${CONTENT_BASE_URL}/enquiries`, payload);
};

const SubscribeToNewsLetter = async (email: string) => {
  return await axios.post(`${API_BASEURL}/newsletter-subscription/subscribe`, { email });
};

export { sendContactMessageApi, SubscribeToNewsLetter };
